import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toggleCreateNoteForm } from 'services/annotations/duck';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { ANNOTATION_CREATE } from 'constants/capabilities';
import { ChannelActionButton } from 'components/atoms/buttons/ChannelActions';

const ProtectedCreateNewNote = ProtectedComponent({
    requiredCapabilities: [ANNOTATION_CREATE]
})(props => (<ChannelActionButton className="hidden-print" icon={'icon-annotations'} iconSize={'22px'} text={'Add New Note'} onClick={props.onClick} />));


class CreateNewNote extends Component {
    render() {
        const isDisabled = this.props.isDisabled;
        const createNoteClick = () => this.props.toggleCreateNoteForm(true);
        if (isDisabled) {
            return null;
        }

        return (<ProtectedCreateNewNote onClick={createNoteClick} />);
    }
}

CreateNewNote.propTypes = {
    isDisabled: PropTypes.string,
};

export default connect(null, {
    toggleCreateNoteForm,
})(CreateNewNote);



// WEBPACK FOOTER //
// ./src/containers/buttons/CreateNewNote.js